module.exports = __webpack_public_path__ + "static/media/kpm.2fcc2d15.png";